import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  keyword: validatePresence(true),
  reason: validatePresence(true),
};
